import { Check } from 'lucide-react';
import { packages } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const Packages = ({ onBookNow }) => {
  const [ref, isInView] = useInView();

  return (
    <section id="packages" className="section-gap bg-obsidian relative overflow-hidden">
      {/* Ambient warm glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-amber/[0.015] rounded-full blur-[200px]" />

      <div ref={ref} className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div
          className={`text-center mb-20 transition-all duration-900 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-8 h-px bg-amber/20" />
            <span className="font-body text-[11px] tracking-[0.4em] uppercase text-amber/50">
              Packages
            </span>
            <div className="w-8 h-px bg-amber/20" />
          </div>
          <h2 className="font-heading text-[2.5rem] md:text-[3.5rem] font-light text-ivory">
            Choose Your <em className="italic text-amber">Experience</em>
          </h2>
          <p className="font-body text-[14px] text-ivory/25 mt-4 max-w-md mx-auto font-light">
            Every package promises an unforgettable evening under the stars.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {packages.map((pkg, index) => (
            <div
              key={pkg.id}
              className={`card-premium relative border rounded-sm p-8 lg:p-9 flex flex-col ${
                index === 0
                  ? 'border-amber/15 bg-obsidian-card/80'
                  : 'border-amber/[0.06] bg-obsidian-card/40'
              } ${
                isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionProperty: 'opacity, transform, border-color', transitionDuration: '0.8s', transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)', transitionDelay: isInView ? `${index * 150 + 200}ms` : '0ms' }}
            >
              {/* Tag */}
              <span className="font-body text-[9px] tracking-[0.3em] uppercase text-amber/50 mb-6">
                {pkg.tag}
              </span>

              {/* Name */}
              <h3 className="font-heading text-2xl font-medium text-ivory mb-1">
                {pkg.name}
              </h3>
              <p className="font-body text-[12px] text-ivory/25 mb-8">{pkg.subtitle}</p>

              {/* Price */}
              <div className="flex items-baseline gap-1.5 mb-9">
                <span className="font-body text-[3rem] font-semibold text-amber leading-none tracking-tight">
                  {pkg.priceLabel}
                </span>
                {pkg.priceUnit && (
                  <span className="font-body text-[13px] text-ivory/25">{pkg.priceUnit}</span>
                )}
              </div>

              {/* Divider */}
              <div className="w-full h-px bg-amber/[0.06] mb-8" />

              {/* Features */}
              <ul className="flex-1 space-y-3.5 mb-10">
                {pkg.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <Check size={13} className="text-amber/50 mt-1 shrink-0" />
                    <span className="font-body text-[13px] text-ivory/35 font-light">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button
                onClick={() => onBookNow(pkg.id)}
                className={`w-full font-body text-[12px] font-medium tracking-[0.12em] uppercase py-3.5 rounded-sm transition-all duration-400 ${
                  index === 0
                    ? 'btn-shimmer bg-amber/90 text-obsidian hover:bg-amber hover:shadow-[0_6px_30px_rgba(200,149,109,0.15)]'
                    : 'border border-amber/15 text-amber/70 hover:bg-amber/[0.05] hover:border-amber/25'
                }`}
              >
                Reserve Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
